// The Link Resolver takes a Prismic document as its argument
export default function(doc) {
  if (doc.type === "homepage") return "/";
  if (doc.type === "news_post") return "/news/" + doc.uid;
  if (doc.type === "careers_post") return "/careers/" + doc.uid;
  if (doc.uid) return "/" + doc.uid;
  return "/404";
}